import { APIClient } from '../../helpers/api_helper';
const AxiosClient = new APIClient()
const createStakeholder = payload => AxiosClient.post('/stakeholder', payload);
const getStakeholderList = (params) => AxiosClient.get('/stakeholder', params);
const updateStakeholder = (stakeholder, payload) => AxiosClient.put(`/stakeholder/${stakeholder}`, payload);
const deleteStakeholder = (stakeholder, query) => AxiosClient.delete(`/stakeholder/${stakeholder}?projectId=${query.projectId}`);

export {
    createStakeholder,
    getStakeholderList,
    updateStakeholder,
    deleteStakeholder
}